var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayground({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1672_482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 3H15",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 9H14",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99993 3V9L5.99993 20C5.95168 20.0971 5.92663 20.204 5.92676 20.3124C5.92688 20.4208 5.95218 20.5277 6.00066 20.6246C6.04913 20.7216 6.11946 20.806 6.2061 20.8711C6.29274 20.9362 6.39333 20.9804 6.49993 21H17.4999C17.6065 20.9804 17.7071 20.9362 17.7938 20.8711C17.8804 20.806 17.9507 20.7216 17.9992 20.6246C18.0477 20.5277 18.073 20.4208 18.0731 20.3124C18.0732 20.204 18.0482 20.0971 17.9999 20L13.9999 9V3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1672_482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayground);
export default __webpack_public_path__ + "static/media/playground.45a5fea0fdac1b507b5e4a047f1ec8d1.svg";
export { ForwardRef as ReactComponent };